import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import GeneViewerIcon from "assets/images/icons/gene-viewer-nero.svg";
import CustomPanelIcon from "assets/images/icons/custom-panel-nero.svg";
import RequestOrderIcon from "assets/images/icons/request-order-nero.svg";
import useDialog from "hooks/useDialog";

interface ILimitedFunction {
  icon: string;
  iconAlt: string;
  title: string;
}

const limitedFunctions: ILimitedFunction[] = [
  {
    icon: GeneViewerIcon,
    iconAlt: "Gene module icon",
    title: "View Gene Modules",
  },
  {
    icon: CustomPanelIcon,
    iconAlt: "Custom panel icon",
    title: "Create Custom Panels",
  },
  {
    icon: RequestOrderIcon,
    iconAlt: "Request quote icon",
    title: "Request a Quote",
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  functionList: {
    '& li + li': {
      [theme.breakpoints.down('sm')]: { marginTop: theme.spacing(2)}
    }
  },
  functionTitle: { marginLeft: 12 },
  marketingCard: {
    '& > div:first-child': {
      borderTopRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: theme.shape.borderRadius
    }
  }
}));

const LimitedFunction = (limitedFunction: ILimitedFunction) => {
  const classes = useStyles();

  return (
    <Box
      component="li"
      key={limitedFunction.title}
      display="flex"
      alignItems="center"
      px={1}
    >
      <img src={limitedFunction.icon} alt={limitedFunction.iconAlt} />
      <Typography
        variant="h6"
        component="p"
        className={classes.functionTitle}
      >
        {limitedFunction.title}
      </Typography>
    </Box>
  );
};

export interface IMarketingMessage {
  // message box only has box shadow on catalog page
  hasElevation?: boolean;
}

const MarketingMessage = ({hasElevation}: IMarketingMessage) => {
  
  const classes = useStyles();
  const { setOpenLoginDialog } = useDialog();
  const isBetween = useMediaQuery((theme: Theme) => theme.breakpoints.between(420, 639));
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  
  return (
    <Box
      id="marketing-message-container"
      boxShadow={hasElevation? 2 : 0}
      bgcolor={'background.paper'}
      borderRadius="4px"
      className={classes.marketingCard}
    >
      <Box
        bgcolor="primary.dark"
        height={isMobile? 'inherit' : 56}
        px={isMobile? 2.5 : 1}
        py={isMobile? 2 : 0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h4" color="white" align="center">
          Assay Marketplace helps you achieve your goal.
        </Typography>
      </Box>
      <Box
        pt={3}
        px={3}
        pb={4}
        display="flex"
        flexDirection="column"
        alignItems="center"
        width={isBetween? '60%' : undefined}
        mx={isBetween? 'auto' : undefined}
      >
        <Typography variant="subtitle1" component="h5">Register and login to...</Typography>
        <Box
          component="ul"
          width={1}
          my={3}
          p={0}
          display="flex"
          flexDirection={isMobile? 'column' : 'row'}
          justifyContent="space-around"
          className={classes.functionList}
        >
          {limitedFunctions.map(LimitedFunction)}
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenLoginDialog(true)}
          fullWidth={isMobile}
        >
          Sign in
        </Button>
      </Box>
    </Box>
  );
};

export default MarketingMessage;
